import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslator } from '@/hooks/useTranslator';

export const AiPriseResumeButton: React.FC = (): React.ReactElement => {
  const tr = useTranslator();
  const navigate = useNavigate();

  const handleClick = React.useCallback((): void => {
    navigate('resume-verification');
  }, [navigate]);

  return (
    <Button variant="contained" size="compact" onClick={handleClick}>
      {tr('RESUME_VERIFICATION')}
    </Button>
  );
};
